// extracted by mini-css-extract-plugin
export default {"main":"SettingsPage_main__hi0L5"};